import { features } from '@kdcloudjs/table';
function colGroupExtendable(pipeline, columnGroupExtend) {
  if (columnGroupExtend) {
    pipeline.use(features.colGroupExtendable(columnGroupExtend));
  }
}
export default colGroupExtendable;